























































import { defineComponent, PropType } from '@vue/composition-api';

import BaseButton from '@/base/app/components/atoms/BaseButton.vue';
import BaseTable from '@/base/app/components/molecules/BaseTable.vue';

import {
  PropsUserUsageTraineeTable,
  UserUsageTraineeAverage,
  UserUsageTraineeItem,
  useUserUsageTraineeTable,
} from './UserUsageTraineeTableComposable';

type Props = PropsUserUsageTraineeTable;
export default defineComponent({
  name: 'ReportUserUsageTraineeTable',
  components: { BaseButton, BaseTable },
  inheritAttrs: false,
  props: {
    groupId: { type: String, required: true },
    records: { type: Array as PropType<UserUsageTraineeItem[]>, default: () => [] },
    average: { type: Object as PropType<UserUsageTraineeAverage>, required: true },
  },
  setup(props: Props) {
    return useUserUsageTraineeTable(props);
  },
});
